import type { LucideIcon } from 'lucide-react';
import type { FC, ReactNode } from 'react';

interface InvestigationsEmptyStateProps {
  title: string;
  body?: string;
  /** When set, renders a circular icon above the title. */
  icon?: LucideIcon;
  /** Use display typography for the primary empty headline. */
  titleDisplay?: boolean;
  action?: ReactNode;
}

/**
 * Shared empty / error layout for Investigations list and detail item tabs.
 */
export const InvestigationsEmptyState: FC<InvestigationsEmptyStateProps> = ({
  title,
  body,
  icon: Icon,
  titleDisplay = false,
  action,
}) => {
  return (
    <div className="tw flex flex-1 flex-col items-center px-4 pt-16 text-center">
      {Icon || action || titleDisplay ? (
        <div className="tw flex flex-col items-center gap-2">
          {Icon && (
            <div className="tw mb-2 flex items-center justify-center rounded-full bg-background-elevated p-4">
              <Icon className="tw size-6 text-foreground-muted" />
            </div>
          )}
          <div className={`tw flex flex-col items-center ${action ? 'tw gap-4' : ''}`}>
            <p
              className={`tw text-foreground-primary ${titleDisplay ? 'heading-display' : 'heading-sm'}`}
            >
              {title}
            </p>
            {body && <p className="tw mt-1 text-foreground-muted body-sm">{body}</p>}
            {action}
          </div>
        </div>
      ) : (
        <>
          <p className="tw text-foreground-primary heading-sm">{title}</p>
          {body && <p className="tw mt-1 text-foreground-muted body-sm">{body}</p>}
        </>
      )}
    </div>
  );
};
